module.exports = __webpack_public_path__ + "img/activity-5.4134b65f.jpg";